import React from 'react';
import { useParams, Redirect } from "react-router-dom";
import { IsJsonString } from "../Utils/Utils";
import cookie from 'react-cookies';

export default function FromPage(props)
{
    let { userdata } = useParams();

    const decoded = atob(userdata);
    const parsed = IsJsonString(decoded) ? JSON.parse(decoded) : undefined;

    if (parsed === undefined)
    {
        return(
            <Redirect
            to={{
            pathname: "/"}}/>
            );
    } else {
        cookie.save("hrsj_dir_userdata",parsed);
        const hospital = parsed.Hospital;
        if (hospital === "LC" || hospital === "VR" )
            props.sethospital(parsed.Hospital);
        props.setuser(parsed);
        return(
            <Redirect
            to={{
            pathname: "/dashboard"}}/>
            );
    }    
}